import React, { useState, useEffect, useRef, Component } from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../component/loadingbar/Spinner";

const AddEmailTmplt = () => {
  const token = config.token;
  const { id } = useParams();
  const navigate = useNavigate();

  // ---------------------------------- state handling ----------------------------------------
  const [loading, setLoading] = useState(false);
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [templateFor, setTemplateFor] = useState();
  const [selectedTemplates, setSelectedTemplates] = useState([]);

  const handleSelectedEmailTemp = (e) => {
    setTemplateFor(e.target.value);
  };

  // --------------------------------------------- read / get template list -------------------------------------------R
  useEffect(() => {
    // --------------------------Fetch template list
    fetch(`${config.host_url}email-templates/lists`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          //   console.log(data.data);
          setEmailTemplates(data.data);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching Student:", error);
      });

    // --------------------------Fetch selected template list
    fetch(`${config.host_url}email-templates`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          //   console.log(data.data);
          setSelectedTemplates(data.data);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching Student:", error);
      });
  }, [token]);

  // --------------------------------------------- choose template  -------------------------------------------R
  const ChooseTemplateBtn = async () => {
    try {
      if (!templateFor) {
        triggerNotification("error", "Input fields cannot be empty!!");
        return;
      }

      await fetch(`${config.host_url}email-templates`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
        body: JSON.stringify({
          template_for: templateFor,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification(
              "success",
              "Email Template selected successfully."
            );
            setTemplateFor("");

            // navigate("/viewsection");
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          triggerNotification("error", "Please try after sometime");
          console.error("Fetch error:", error);
        });
    } catch (error) {
      console.error("Error creating Notification:", error);
      triggerNotification(
        "error",
        "An error occurred while creating the Notification."
      );
    }
  };

  return (
    <>
      <Breadcrumb
        txt="Manage Email Template"
        subpath={["Add Email Template"]}
      />
      {/* form view */}
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center ">
            <h5 className="mb-0">Add Email Template</h5>
          </div>

          <div className="card-body">
            <form>
              {loading ? (
                <Spinner />
              ) : (
                <>
                  <div className="form-floating form-floating-outline mb-4">
                    <select
                      className="form-select"
                      name="classid"
                      id="classid"
                      aria-label="Select Email Template"
                      value={templateFor}
                      onChange={handleSelectedEmailTemp}
                    >
                      <option
                        value=""
                        disabled
                        selected
                        className="text-center"
                      >
                        Select Email Template
                      </option>
                      {emailTemplates.map((emailTemp) => (
                        <option key={emailTemp} value={emailTemp}>
                          {emailTemp}
                        </option>
                      ))}
                    </select>
                    <label htmlFor="classid">Email Template</label>
                  </div>
                  {templateFor && (
                    // submit btn
                    <div className="mt-3 justify-content-end">
                      <div className="col-sm-10">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={ChooseTemplateBtn}
                        >
                          {id ? "Update" : "Submit"}
                        </button>
                      </div>
                    </div>
                  )}
                </>
              )}
            </form>
          </div>
        </div>
      </div>

      {/* show selected template */}
      <>
        {loading ? (
          <Spinner />
        ) : (
          <div className="col-xxl">
            <div className="card ">
              <div className="card-header align-items-center ">
                {selectedTemplates.map((template, i) => (
                  <div key={i} className="input-group w-full my-2">
                    <p
                      className="form-control "
                      aria-label="Text input with radio button"
                    >
                      {template.template_for}
                    </p>

                    <button
                      type="button"
                      className="btn btn-outline-secondary h-10"
                      onClick={() =>
                        navigate(
                          "/emailtmplteditor/" +
                            btoa(encodeURIComponent(template.eid)) +
                            "/" +
                            btoa(encodeURIComponent(template.template_for))
                        )
                      }
                    >
                      Edit Template
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </>
    </>
  );
};

export default AddEmailTmplt;
